// The company and supplier pickers on this screen are comboboxes now (combobox.js);
// what is left here is the rest of the filter form: the plain selects submit on
// change, and the cross next to the supplier field empties it.
document.addEventListener('DOMContentLoaded', () => {
  const selectInvoicesForm = document.getElementById('select-company-e-invoices');

  if (!selectInvoicesForm) return;

  const selectElements = selectInvoicesForm.querySelectorAll('select');

  selectElements.forEach((select) => {
    select.addEventListener('change', function() {
      selectInvoicesForm.submit();
    });
  });

  document.querySelectorAll('.clear-input').forEach(clearButton => {
    clearButton.addEventListener('click', function(e) {
      e.preventDefault()
      const inputGroup = this.closest('.input-group');
      const inputField = inputGroup.querySelector('input.form-control');

      // Clear the input field
      if (inputField) {
        if(inputField.value.length === 0) return;

        inputField.value = '';

        const relatedHiddenInput = document.querySelector(`input[type="hidden"][name="${inputField.name.replace('_name', '_id')}"]`);
        if (relatedHiddenInput) {
          relatedHiddenInput.value = '';
        }

        inputGroup.closest('form').submit();
      }
    });
  });
});
